import React, { useEffect, useRef, useState } from 'react'
import FormComponent from '../../../../components/gernerateForm/FormComponent'
import { Grid, MenuItem, Typography } from '@mui/material';
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import { ReactComponent as Icon_upload } from '../../../../assets/icons/upload-file.svg'
import { ReactComponent as AddSquare } from '../../../../assets/icons/add-square-green.svg'
import { ReactComponent as Bag } from '../../../../assets/icons/bag-button.svg'
import { ReactComponent as Document } from '../../../../assets/icons/document.svg'
import InputTextField from '../../../../components/input/inputTextField';
import InputDatePicker from '../../../../components/input/inputDatePicker';
import moment from 'moment';
import { swalError } from '../../../../components/alert/swal';
import FilterSelect from '../../../../components/select/filterSelect';
import { MeetingTypeApi } from '../../../../api/meeting-type/meeting-type.api';
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import { useParams } from 'react-router-dom';
import UploadFile from '../../../../components/upload/UploadFile';
import ContentHeading from '../../../../components/layout/content/ContentHeading';
import { dateToView } from '../../../../utils/date.utils';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import { useTranslation } from 'react-i18next';
export default function MeetingDetail(props: any) {
  const { formMeetingRoom, setFormMeetingRoom } = props
  const { id } = useParams();
    const { t } = useTranslation();

  const [meetingType, setMeetingType] = useState<any[]>([])
  const getMeetingType = async () => {
    let condition: any = {
      page: 1,
      limit: 100
    };

    const res = await MeetingTypeApi.list(condition);
    const data = res.data
    setMeetingType(data.data.items)
  }

  useEffect(() => {
    getMeetingType()
  }, [])

  return (
    <section className="w-full mt-10">

      <section className="w-full flex justify-between items-center gap-[4px]">
        <div>
          {props?.contentleft}
        </div>
        <div className='flex flex-col justify-center items-center'>
          <Typography variant='h3'>
            {formMeetingRoom?.meeting_room_name}
          </Typography>
          <Typography>
            {`วันที่ดำเนินการ : ${dateToView(formMeetingRoom?.meeting_room_start_date)}   เวลาดำเนินการ : ${formMeetingRoom?.meeting_room_start_time} - ${formMeetingRoom?.meeting_room_end_time}`}
          </Typography>
        </div>
        <div>
          {props?.contentRight}
        </div>

      </section>
      <Grid container spacing={2}>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
           heading={t('MEETING_CATEGORY.DETAILS')}
           placeholder={t('MEETING_CATEGORY.DETAILS')}
            value={formMeetingRoom?.meeting_room_desc}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_desc: e.target.value })
            }
            }
            helperText={
              ""
            }
            disabled={true}
            row={3}
            maxRows={5}
            disablePaddingMultiline
            multiline
            inputHeight={"auto"}
          />
        </Grid>


        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <div style={{ display: 'flex', flexDirection:"column", gap: '10px', marginTop: '10px', width: "100%" }}>
           <Typography>ลิงก์ออนไลน์</Typography>
            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px',alignItems:'center' }}>
                <LinkOutlinedIcon sx={{color:'#7e7e7e'}}/>
                <Typography sx={{cursor:'pointer', textDecoration:'underline', color:'#2186E3'}} onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(formMeetingRoom?.meeting_room_link, '_blank');

                }}>{formMeetingRoom?.meeting_room_link}</Typography>
              </div>

              <ButtonPrimary
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  navigator.clipboard.writeText(formMeetingRoom?.meeting_room_link);

                }}
                buttonName="คัดลอก"
                btnProps={{
                  width: "150px",
                  bg: '#0F9F0C'
                }}
              />
            </div>

          </div>
          {/* <InputTextField
            heading={'ลิงก์ออนไลน์'}
            placeholder={'ลิงก์ออนไลน์'}
            value={formMeetingRoom?.meeting_room_link}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_link: e.target.value })
            }
            }
            helperText={
              ""
            }
            disabled={true}
          /> */}
        </Grid>
      </Grid>


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.MEETING_CONTENTS')}</Typography>

      </div>
      {formMeetingRoom?.meeting_file_contents?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>


            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Document />
                <div style={{ display: "flex", alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                  {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                </div>
              </div>

              <ButtonOutlined
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                }}
                buttonName="ดาวน์โหลดไฟล์"
                btnProps={{
                  width: "150px",
                  // border: '#0F9F0C'
                }}
              />
            </div>
          </div>
        )
      })}


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.MEETING_AGENDA')}</Typography>

      </div>
      {formMeetingRoom?.meeting_file_agenda?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>
            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Document />
                <div style={{ display: "flex", alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                  {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                </div>
              </div>

              <ButtonOutlined
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');

                }}
                buttonName="ดาวน์โหลดไฟล์"
                btnProps={{
                  width: "150px",
                  // border: '#0F9F0C'
                }}
              />
            </div>

          </div>
        )
      })}


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.ATTACH_ADDITIONAL_DOCUMENTS')}</Typography>
      </div>
      {formMeetingRoom?.meeting_file_other?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Document />
                <div style={{ display: "flex", alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                  {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                </div>
              </div>

              <ButtonOutlined
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');

                }}
                buttonName="ดาวน์โหลดไฟล์"
                btnProps={{
                  width: "150px",
                  // border: '#0F9F0C'
                }}
              />
            </div>
          </div>
        )
      })}

      {/* <ButtonOutlined
          onClick={() => {
            // handleSubmit(inputValueFormStudent.information);
          }}
          buttonName="ลบ"
          btnProps={{
            width: "100px",
          }}
        /> */}

    </section>
  )
}
